import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { FlattenedExamSession } from '../types/exam-types';
import {
  SectionHeader,
  SectionWrapper,
  EmptyState,
  sessionTypeTemplate,
  sessionDateTemplate,
  registrationDatesTemplate,
  eligibilityTemplate,
  getSessionTypeLabel,
} from './componenets/exam-shared-components';

interface OpenForRegistrationExamsProps {
  sessions: FlattenedExamSession[];
}

export const OpenForRegistrationExams: React.FC<
  OpenForRegistrationExamsProps
> = ({ sessions }) => {
  const handleRegister = (session: FlattenedExamSession) => {
    toast.success(
      `נרשמת בהצלחה למבחן "${session.examName}" - ${getSessionTypeLabel(session.sessionType)}`,
    );
  };

  const registerActionTemplate = (session: FlattenedExamSession) => {
    return (
      <Button
        label="הרשמה למועד"
        icon="pi pi-check"
        size="small"
        severity="success"
        onClick={() => handleRegister(session)}
      />
    );
  };

  return (
    <SectionWrapper>
      <SectionHeader
        title="מבחנים פתוחים להרשמה"
        icon="pi pi-calendar-plus"
        count={sessions.length}
        accentColor="#22C55E"
      />
      <div style={{ padding: '16px' }}>
        {sessions.length > 0 ? (
          <DataTable
            value={sessions}
            stripedRows
            showGridlines
            tableStyle={{ minWidth: '50rem' }}
          >
            <Column
              field="examName"
              header="שם המבחן"
              style={{ textAlign: 'right', fontWeight: 'bold' }}
            />
            <Column
              field="courseName"
              header="קורס"
              style={{ textAlign: 'right' }}
            />
            <Column
              header="מועד"
              body={sessionTypeTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="תאריך מבחן"
              body={sessionDateTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="תקופת הרשמה"
              body={registrationDatesTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="זכאות"
              body={eligibilityTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="פעולות"
              body={registerActionTemplate}
              style={{ textAlign: 'center', width: '150px' }}
            />
          </DataTable>
        ) : (
          <EmptyState message="אין מבחנים פתוחים להרשמה כרגע" />
        )}
      </div>
    </SectionWrapper>
  );
};
